
import { defineComponent } from "vue";
import Terms from "./terms.vue";
export default defineComponent({
  name: "resetPassword",
  components: {
    Terms,
  },
});
